
const DialogMessage = ({ children }) => {

    return (
        <p className="dialog-message">{children}</p>
    )
}

export default DialogMessage;
